import { forwardRef } from "react";
function SvgReorderIconRaw({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="#545454"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 2v16M18 10H2M11.92 16 10 18.4 8.08 16h3.84ZM11.92 4 10 1.6 8.08 4h3.84ZM16 8.08 18.4 10 16 11.92V8.08ZM4 8.08 1.6 10 4 11.92V8.08Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgReorderIconRaw);
export default ForwardRef;
